<template>
  <v-dialog v-model="showDetailDialog" max-width="60%" persistent>
    <v-card class="window-card px-4 py-5">
      <v-progress-linear color="#4caf50" indeterminate v-if="uploadProgress !== ''"   height="20">
          <p style="line-height:20px; height:20px; text-align: center; font-size: 16px; color: #fff; margin-bottom:0;">
            {{ uploadProgress }}
          </p>
        </v-progress-linear>
      <v-card-title>
        <span class="md-title" style="color: #67ad5b">特效模型信息</span>
      </v-card-title>

      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tabs-slider color="green"></v-tabs-slider>
        <v-tab
          v-for="(item, index) in items"
          :key="item"
          :class="index == 0 ? 'viewModelTab' : 'viewModePreview'"
        >
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-form class="pa-10"  >
            <v-text-field
              v-model="currentResource.effects_name"
              label="名称 *"
              color="#4caf50"
              :rules="[v => !!v || '名称不能为空']"
              class="model_name"
            ></v-text-field>

            <v-select
              v-model="currentResource.effects_type"
              :items="effectsList"
              item-text="name"
              color="#4caf50"
              item-value="type"
              label="类型 *"
              no-data-text="暂无数据"
              :rules="[v => !!v || '类型不能为空']"
              class="model_category"
            ></v-select>


         
            <v-file-input
            truncate-length="15"
            color="#4caf50"
            label="特效模型预览图片上传"
            @change="f => (currentResource.effects_review_img = fileChange(f))"
            v-model="currentResource.effects_review_img"
            accept="image/*"
            show-size
          ></v-file-input>
            

            <v-file-input
              truncate-length="15"
              color="#4caf50"
              label="特效模型上传"
              @change="f =>(currentResource.effects_file = fileChange(f))"
              :value="currentResource.effects_file"
              show-size
              accept=".FBX,.fbx"
            ></v-file-input>

            <v-textarea
              v-model="currentResource.effects_description"
              label="描述"
              color="#4caf50"
            ></v-textarea>

            <v-textarea
              v-model="currentResource.effects_remark"
              label="申请备注"
              color="#4caf50"
            ></v-textarea>

    
          </v-form>
        </v-tab-item>
        <v-tab-item>
          <iframe
            :src="editorUrl"
            ref="iframe"
            width="100%"
            scrolling="no"
            style="min-height: calc(65vh)"
          ></iframe>
          <!-- <iframe :src="" ref="iframe" width="100%"
            scrolling="no" style="min-height: calc(65vh)"></iframe> -->
        </v-tab-item>
      </v-tabs-items>
       <v-card-actions v-if="isMobile.isMobile" class="md-layout md-gutter md-alignment-center-center BtnsWrap">
        <v-spacer></v-spacer>

<!--         
        <v-btn
          v-hasPermi="['dev::model::updateModel']"
          color="success"
          class="updateModel md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-15 md-small-size-20 md-xsmall-size-45"
          small
          @click="showUploadUpdateModel = true"
          >更新模型</v-btn
        >
        <v-btn
          v-hasPermi="['dev::model::download']"
          color="success"
          class="downModel md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-15 md-small-size-20 md-xsmall-size-45"
          small
          @click="download"
          >下载模型原件</v-btn
        >
        <v-btn
          v-hasPermi="['dev::model::edit']"
          color="success"
          class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-5 md-small-size-15 md-xsmall-size-25"
          @click="submit"
          small
          >确定</v-btn
        >
        <v-btn
          v-hasPermi="['dev::model::remove']"
          color="error"
          class="delModel md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-5 md-small-size-15 md-xsmall-size-25"
          @click="delete_"
          small
          >删除</v-btn
        >
        <v-btn
          color="success"
          class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-5 md-small-size-15 md-xsmall-size-25"
          @click="cancel"
          small
          >关闭</v-btn
        > -->


        <v-menu top :close-on-content-click="closeOnContentClick">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="success" dark v-bind="attrs" v-on="on"> 操作 </v-btn>
          </template>

          <v-list>
            <v-list-item link v-hasPermi="['dev::model::updateModel']">
              <v-list-item-title @click="showUploadUpdateModel=true">更新模型</v-list-item-title>
            </v-list-item>

            <v-list-item link v-hasPermi="['dev::model::download']">
              <v-list-item-title @click="download"> 下载模型原件 </v-list-item-title>
            </v-list-item>

            <v-list-item link v-hasPermi="['dev::model::edit']">
              <v-list-item-title @click="submit">确定</v-list-item-title>
            </v-list-item>

            <v-list-item link v-hasPermi="['dev::model::remove']">
              <v-list-item-title @click="delete_"> 删除</v-list-item-title>
            </v-list-item>

            <v-list-item link @click="cancel">
              <v-list-item-title> 关闭 </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-actions>
      <v-card-actions v-else class="md-layout md-gutter md-alignment-center-center BtnsWrap">
        <v-spacer></v-spacer>
        <v-btn
          v-hasPermi="['dev::model::updateModel']"
          color="success"
          class="updateModel md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-15 md-small-size-20 md-xsmall-size-45"
          small
          @click="showUploadUpdateModel = true"
          >更新模型</v-btn
        >
        <v-btn
          v-hasPermi="['dev::model::download']"
          color="success"
          class="downModel md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-15 md-small-size-20 md-xsmall-size-45"
          small
          @click="download"
          >下载模型原件</v-btn
        >
        <v-btn
          v-hasPermi="['dev::model::edit']"
          color="success"
          class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-5 md-small-size-15 md-xsmall-size-25"
          @click="submit"
          small
          >确定</v-btn
        >
        <v-btn
          v-hasPermi="['dev::model::remove']"
          color="error"
          class="delModel md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-5 md-small-size-15 md-xsmall-size-25"
          @click="delete_"
          small
          >删除</v-btn
        >
        <v-btn
          color="success"
          class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-5 md-small-size-15 md-xsmall-size-25"
          @click="cancel"
          small
          >关闭</v-btn
        >
      </v-card-actions>
    </v-card>
    <!-- 算是标准的表单模板，后续需要封装一个 -->
    <v-dialog v-model="showUploadUpdateModel" max-width="500px" transition="dialog-transition">
      <v-card class="d-flex flex-column justify-center white pa-10">
        <v-progress-linear color="#4caf50" indeterminate v-if="uploadProgress !== ''"   height="20">
          <p style="line-height:20px; height:20px; text-align: center; font-size: 16px; color: #fff; margin-bottom:0;">
            {{ uploadProgress }}
          </p>
        </v-progress-linear>
        <v-file-input
          truncate-length="15"
          color="#4caf50"
          label="修改模型上传"
          @change="f => (currentResource.effects_file = f)"
          accept=".fbx,.FBX"
          show-size
        ></v-file-input>

        <v-overlay :value="overlay">
          <v-card class="d-flex flex-column justify-center white px-10">
            <div class="d-flex justify-center py-5">
              <v-progress-circular indeterminate color="success"></v-progress-circular>
            </div>
            <div class="d-flex justify-center pb-5 green--text text-bold">模型资源上传中...</div>
          </v-card>
        </v-overlay>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" v-hasPermi="['dev::model::updateModel']" @click="updateModel" small
            >更新</v-btn
          >
          <v-btn color="success" @click="showUploadUpdateModel = false" small>取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { ImageCard, Pagination } from '@/components';
import { ModelFbx } from 'vue-3d-model';
import Swal from 'sweetalert2';
import model_resource_name_map from '../../../../../common/config/model_resource_name_map';
import { updateModelResource, deleteEffectResource,updateEffectsModel } from '@/api/model_resource';
import { ossUpload } from '@/api/user';


import { saveAs } from 'file-saver';
import { isNull } from '@antv/x6/lib/util/lang/lang';
// import { listTag } from "@/api/tag";
import { mapGetters } from 'vuex';
export default {
  components: {
    ImageCard,
    Pagination,
    ModelFbx,
  },
  props: {
    showDetailDialog: {
      type: Boolean,
      default: false,
    },
    selectedResource: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['isMobile']),
    editorUrl() {
      return `${process.env.VUE_APP_PREVIEW_URL}#/preview?id=${this.currentResource._id}&type=effect`;
    },
    model_resource_category() {
      return model_resource_name_map(this.$route.path);
    },
    // allSelected() {
    //   return this.selected.length === this.items.length;
    // },
    categories() {
      const search = this.search.toLowerCase();

      if (!search) return this.items;

      return this.items.filter(item => {
        const text = item.text.toLowerCase();

        return text.indexOf(search) > -1;
      });
    },
    selections() {
      const selections = [];

      for (const selection of this.selected) {
        selections.push(selection);
      }

      return selections;
    },
  },
  data() {
    return {
      closeOnContentClick:true,
      uploadProgress:'',
      overlay: false,
      effects_file: null,
      showUploadUpdateModel: false,
      tab: 0,
      items: ['基本信息', '模型预览'],
      // 专业分类
      // majorListData: [],
      // 二级分类
      level2: [],
      // 三级分类
      level3: [],
      currentResource:{
        effects_description:null,

        effects_file:null,

        effects_name:null,

        effects_remark:null,

        effects_review_img:null,

        effects_type: null,

        model_amrt_file_list_json:null,

      },
      // :this.selectedResource,
      message: '',
      categoryList: [
        { name: '设备', type: 'device' },
        { name: '角色', type: 'role' },
        { name: '工具', type: 'tool' },
        { name: '场景', type: 'scene' },
      ],
      effectsList: [
        { name: '火', type: 'fire' },
        { name: '烟雾', type: 'smoke' },
      ],
      // allSelected: false,
      loading: false,
      search: '',
      selected: [],
      // tagList: [],
    };
  },
  watch: {
    selected() {
      this.search = '';
    },
    tab(val) {

      if ((val == 1 && !this.currentResource.model_amrt_file_list_json)||this.currentResource.model_amrt_file_list_json=='false') {
        this.$store.dispatch('global/showWarningMsg', '模型尚未转换无法预览');
        this.tab = 0;
      }
    },
  },
  async created() {

    let {effects_description,effects_file, effects_name,effects_remark ,effects_review_img ,effects_type,model_amrt_file_list_json,_id} =this.selectedResource
    this.currentResource.effects_name = effects_name
    this.currentResource._id = _id
    this.currentResource.model_amrt_file_list_json = model_amrt_file_list_json
    this.currentResource.effects_description = effects_description
    this.currentResource.effects_remark = effects_remark
    this.effectsList.forEach(element => {
       if(element.type==effects_type){
          this.$set(this.currentResource,'effects_type',element)
       }
    });


    //模型
    if (effects_file) {
      let resultFile = await this.sliceUrl(effects_file, 'model');
      this.$set(this.currentResource, 'effects_file', resultFile);
    }
 
    // 模型预览图片
    if (effects_review_img) {
       let resultFile = await this.sliceUrl(effects_review_img, 'img');
       this.$set(this.currentResource, 'effects_review_img', resultFile);
    }

  },
  mounted() {
    let that = this;
    this.$EventBus.$on('setTabChange', function (data) {
      if (data == 0) {
        that.tab = 0;
      } else {
        that.tab = 1;
      }
    });
  },
  destroyed() {
    this.$EventBus.$off('setTabChange');
  },
  methods: {
    fileChange(e) {
      console.log({
        e,
        f: this.currentResource,
      });
      return e;
    },
    async sliceUrl(url, type) {
      let index = url.lastIndexOf('/');
      let fileName = url.slice(index).replace('/', '');
      let acceptType = null;
      if (type == 'img') {
        acceptType = 'image/*';
      } else if (type == 'arrImg') {
        acceptType = 'image/*';
      } else if (type == 'video') {
        acceptType = '.mp4';
      } else if (type == 'rar') {
        acceptType = '.rar,.RAR';
      } else if (type == 'zip') {
        acceptType = '.zip,.ZIP';
      } else {
        acceptType = '.FBX,.fbx';
      }

      let resultFile = await this.getFileFromUrl(url, decodeURIComponent(fileName), acceptType)
        .then(response => {
          return response;
        })
        .catch(e => {
          console.error(e);
        });

      return resultFile;
    },
    getFileFromUrl(url, fileName, acceptType) {
      return new Promise((resolve, reject) => {
        var blob = null;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.setRequestHeader('Accept', acceptType);
        xhr.responseType = 'blob';

        // 加载时处理
        xhr.onload = () => {
          // 获取返回结果
          blob = xhr.response;
          let file = new File([blob], fileName, { type: acceptType });

          // 返回结果
          resolve(file);
        };
        xhr.onerror = e => {
          reject(e);
        };
        // 发送
        xhr.send();
      });
    },
    // async getTagList() {
    //   const res = await listTag({ perPage: 1000, currentPage: 1 });
    //   this.tagList = res.data.rows;
    // },
    async updateModel() {
      // this.overlay = true;
      // const res = await ossUpload({ path: 'modelFile', file: this.currentResource.effects_file});
      // this.currentResource.effects_file = res.url;
      this.submit();
    },
    download() {
      let url = /https.*/.test(this.selectedResource.effects_file)
        ? this.selectedResource.effects_file
        : this.selectedResource.effects_file.replace(`http`, 'https');
      console.log('url :>> ', url);
      saveAs(url, `${this.selectedResource.effects_name}.fbx`);
      // window.open(this.currentResource.model_file)
    },
    /**
     * 初始化字典
     */
    // initDict(cate_type) {
    //   this.$dic.getCategoryList(
    //     {
    //       cate_type: cate_type,
    //       level: "1",
    //     },
    //     (res) => {
    //       this.majorListData = res;
    //     }
    //   );

    //   this.$dic.getCategoryList(
    //     {
    //       cate_type: cate_type,
    //       level: "2",
    //       parentCode: "00",
    //     },
    //     (res) => {
    //       this.level2 = res;
    //     }
    //   );

    //   this.$dic.getCategoryList(
    //     {
    //       cate_type: cate_type,
    //       level: "3",
    //       parentCode: "00_01",
    //     },
    //     (res) => {
    //       this.level3 = res;
    //     }
    //   );
    // },
    cancel() {
      this.$emit('handleDetailCancel', {});
    },
   async submit() {


        const form = {
          effects_name:this.currentResource.effects_name,
          effects_type:null,
          effects_review_img:this.currentResource.effects_review_img,
          effects_file:this.currentResource.effects_file,
          effects_description:this.currentResource.effects_description,
          effects_remark:this.currentResource.effects_remark,
          model_amrt_file_list_json :this.currentResource.model_amrt_file_list_json,
          _id:this.currentResource._id,
        }
      
        if(Object.prototype.toString.call(this.currentResource.effects_type) === '[object Object]'){
           form.effects_type = this.currentResource.effects_type.type;
        }else{
         form.effects_type = this.currentResource.effects_type;
        }
        console.log(this.currentResource)


        this.uploadProgress = '开始上传'
        // this.overlay = true;
        if(form.effects_review_img){
           this.uploadProgress = '上传特效预览图...'
           form.effects_review_img = await this.uploadFile('modelImage', form.effects_review_img)
        }
       if (form.effects_file) {
           this.uploadProgress = '上传特效模型...'
           form.effects_file = await this.uploadFile('modelFile',form.effects_file)
      }



      await updateEffectsModel(form)
          .then(res => {
            if (res.code === '200') {
              this.$notify({
                timeout: 1500,
                message: '修改成功！',
                icon: 'add_alert',
                horizontalAlign: 'center',
                verticalAlign: 'bottom',
                type: 'success',
              });
              this.$emit('handleDetailCancel');
            } else {
              this.$notify({
                timeout: 1500,
                message: '修改失败！',
                horizontalAlign: 'center',
                verticalAlign: 'bottom',
                type: 'warning',
              });
            }
    
          })

          .finally(_ => {
            this.uploadProgress = '';
            this.overlay = false;
          });



    

    },
    async uploadFile(fieldName, file) {
      const res = await ossUpload({ path: fieldName, file });
      return res.url;
    },
    async delete_() {
      let tempData = {
        _id: this.currentResource._id,
      };
      let result = await Swal.fire({
        title: '删除信息',
        text: `该特效模型被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });
      if (result.value) {
        await deleteEffectResource(tempData).then(res => {
          if (res.code === '200') {
            this.$notify({
              timeout: 1500,
              message: '删除成功',
              icon: 'add_alert',
              horizontalAlign: 'center',
              verticalAlign: 'bottom',
              type: 'success',
            });
            this.$emit('handleDetailCancel', res.data);
          } else {
            this.$notify({
              timeout: 1500,
              message: '操作失败',
              icon: 'add_alert',
              horizontalAlign: 'center',
              verticalAlign: 'bottom',
              type: 'warning',
            });
          }
        });
      }
    },
  },
};
</script>
<style lang="css" scoped>
.v-card .v-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.img {
  width: 120px;
  height: 180px;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0;
}

.md-tab {
  max-width: 800px;
  max-height: 450px;
  overflow: auto;
}

@media (max-width: 599px) {
  .v-dialog__content >>> .v-dialog {
    background-color: red !important;
    max-width: 100% !important;
    margin: 24px 10px !important;
  }
  .BtnsWrap button {
    margin: 5px 0;
  }
}
</style>
